import { render, staticRenderFns } from "./StripePaymentDone.vue?vue&type=template&id=460b35e9&scoped=true"
import script from "./StripePaymentDone.vue?vue&type=script&lang=js"
export * from "./StripePaymentDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460b35e9",
  null
  
)

export default component.exports